export const iconConfig = {
	defaultStyle: "hover:stroke-accent-foreground transition-colors duration-200",
	defaultFill: "var(--light-gray)",
	defaultStroke: "var(--light-gray)",
	size: 16,
} as const;
